<template>
  <section class="section section3">
    <div class="section-wrap">
      <div class="s3-top-box">
        <h2 class="section3-title">{{$t('home.s3_1')}}</h2>
        <p class="section3-ps">{{$t('home.s3_2')}}</p>
        <div @click="routerSkip('/tech',1)" class="realize-more clearfix">{{$t('common.more')}} <img src="@/assets/images/icon/more-point-right-pw.png"></div>
      </div>
      <div class="s3-bottom-box clearfix">
        <div class="s3-swiper-box">
          <swiper v-if="prizeListFormat.length > 0" :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="item in prizeListFormat">
              <div class="prize-box-wrap clearfix">

                <div v-for="child in item" class="prize-box">
                  <div class="prize-box-bg">
                    <div class="prize-pic" :style="{backgroundImage:'url(' + child.patentImage + '?imageView2/2/w/400/interlace/1'}"></div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="page-num">
            <a-icon type="arrow-left" class="point-icon point-left" />
            <a-icon type="arrow-right" class="point-icon point-right" />
            <span class="page-num-now">{{swiperIndex}}</span> <span class="page-num-total"> / {{prizeListFormat.length}}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
    import { selectPatent } from '@api/index'
  export default {
    name: 'homeSection3',
    data () {
      return {
        swiperIndex: 1,
        swiperOption: {
          speed: 500,
          loop: true,
          grabCursor: true,
          paginationClickable: true,
          nextButton: '.point-right',
          prevButton: '.point-left',
          onSlideChangeStart: swiper => {
            let num = swiper.realIndex + 1
            this.swiperIndex = num
          }
        },
          listQuery:{
              number:20,
              page:1,
              totalPage:1,
              total:18
          },
        prizeList: [{
          id: 1,
          patentImage: require('@/assets/images/tech/patent/1.jpg')
        },{
          id: 2,
          patentImage: require('@/assets/images/tech/patent/2.jpg')
        },{
          id: 3,
          patentImage: require('@/assets/images/tech/patent/3.jpg')
        },{
          id: 4,
          patentImage: require('@/assets/images/tech/patent/4.jpg')
        },{
          id: 5,
          patentImage: require('@/assets/images/tech/patent/5.jpg')
        },{
          id: 6,
          patentImage: require('@/assets/images/tech/patent/6.jpg')
        },{
          id: 7,
          patentImage: require('@/assets/images/tech/patent/7.jpg')
        },{
          id: 8,
          patentImage: require('@/assets/images/tech/patent/8.jpg')
        },{
          id: 9,
          patentImage: require('@/assets/images/tech/patent/9.jpg')
        },{
          id: 10,
          patentImage: require('@/assets/images/tech/patent/10.jpg')
        },{
          id: 11,
          patentImage: require('@/assets/images/tech/patent/11.jpg')
        },{
          id: 12,
          patentImage: require('@/assets/images/tech/patent/12.jpg')
        },{
          id: 13,
          patentImage: require('@/assets/images/tech/patent/13.jpg')
        },{
          id: 14,
          patentImage: require('@/assets/images/tech/patent/14.jpg')
        },{
          id: 15,
          patentImage: require('@/assets/images/tech/patent/15.jpg')
        },{
          id: 16,
          patentImage: require('@/assets/images/tech/patent/16.jpg')
        },{
          id: 17,
          patentImage: require('@/assets/images/tech/patent/17.jpg')
        },{
          id: 18,
          patentImage: require('@/assets/images/tech/patent/18.jpg')
        },{
          id: 19,
          patentImage: require('@/assets/images/tech/patent/19.jpg')
        },{
          id: 20,
          patentImage: require('@/assets/images/tech/patent/20.jpg')
        },{
          id: 21,
          patentImage: require('@/assets/images/tech/patent/21.jpg')
        }],
        prizeListFormat: []
      }
    },
    created () {
        this.listQuery.languageType = this.$i18n.locale
      this.getList()
    },
    methods: {
        getList() {
            let formatList = []
            selectPatent(this.listQuery).then(res=>{
                if(res.code==0){
                    res.data.list.forEach((val,index) => {
                        let num = Math.floor(index / 4)
                        if (typeof formatList[num] === 'object') {
                            formatList[num].push(val)
                        } else {
                            formatList[num] = []
                            formatList[num].push(val)
                        }
                    })
                    this.prizeListFormat = formatList
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
      // getList() {
      //   let formatList = []
      //   this.prizeList.forEach((val,index) => {
      //     let num = Math.floor(index / 4)
      //     if (typeof formatList[num] === 'object') {
      //       formatList[num].push(val)
      //     } else {
      //       formatList[num] = []
      //       formatList[num].push(val)
      //     }
      //   })
      //   this.prizeListFormat = formatList
      // }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .section3
    background-image url("~@/assets/images/home/3-bg.png");bgCover()
    .s3-top-box
      rela();width 100%;padding .65rem 0;
      .section3-title
        font-size .36rem;font-weight normal;color #fff
      .section3-ps
        margin-top .08rem;font-size .14rem;color #fff
      .realize-more
        abso();right 0;bottom .68rem;width: 1.05rem;height: .36rem;border-bottom .02rem solid #fff;line-height .34rem;color #fff;cursor pointer
        img
          fr();margin-top .08rem;width: .24rem;height: .16rem;
    .s3-bottom-box
      width: 100%;height: 5.43rem
      .s3-swiper-box
        rela();height: 100%
        .swiper-container
          height: 5.43rem
        .swiper-slide
          height:5.43rem;cursor -webkit-grab
          .prize-box
            fl();width 25%;padding 0 .05rem
            .prize-box-bg
              height: 5.43rem;padding-top .2rem;background-image url("~@/assets/images/home/prize-box.png");background-repeat no-repeat;background-position top center;background-size contain
            .prize-pic
              margin 0 auto;width: 2.5rem;height: 3.55rem;border-radius .05rem;bgCover()

  .page-num
    abso();bottom .64rem;left 0;right 0;margin: auto;width: 1.1rem;height: .2rem;text-align center;line-height .2rem;color #fff;z-index 1
  .page-num-now
    font-size .16rem
  .page-num-total
    font-size .12rem
  .point-icon
    display inline-block;abso();top .03rem;bottom 0;margin: auto;width: .2rem;height: .2rem;font-size .16rem;cursor pointer
  .point-left
    left 0;
  .point-right
    right 0
</style>
